import React from "react";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";

const specialties = [
  { icon: "fas fa-brain", label: "AI & Machine Learning" },
  { icon: "fas fa-database", label: "Data Engineering" },
  { icon: "fas fa-cloud", label: "Cloud & DevOps" },
  { icon: "fas fa-code", label: "Full-Stack Development" },
];

const AboutMe = ({ heading, message, link, imgSize, resume }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const imgSpring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateX(0)" : "translateX(-40px)",
    config: { tension: 180, friction: 30 },
  });

  const textSpring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateX(0)" : "translateX(40px)",
    config: { tension: 180, friction: 30 },
  });

  return (
    <section id="aboutme" className="about-section">
      <div ref={ref} className="about-inner">
        {link && (
          <animated.div style={imgSpring} className="about-img-wrap">
            <img
              src={link}
              alt="Profile"
              className="about-img"
              width={imgSize}
              height={imgSize}
            />
          </animated.div>
        )}

        <animated.div style={textSpring} className={`about-content${!link ? " about-content--full" : ""}`}>
          <h2 className="display-4 mb-4">{heading}</h2>
          <p className="about-message">{message}</p>

          <div className="about-specialties">
            {specialties.map((s, i) => (
              <span key={i} className="about-specialty">
                <i className={s.icon} />
                {s.label}
              </span>
            ))}
          </div>

          {resume && (
            <div style={{ textAlign: "center" }}>
              <a
                href={resume}
                target="_blank"
                rel="noreferrer noopener"
                className="about-resume-btn"
                aria-label="Download Resume"
              >
                Download CV
                <i className="fas fa-download" style={{ marginLeft: "8px" }} />
              </a>
            </div>
          )}
        </animated.div>
      </div>
    </section>
  );
};

export default AboutMe;
